import $ from "jquery"
import SpinnerController from "../../../SpinnerController";
import Spinner from "../../../spin.min"

const ChartPDFViewer = function() {}

ChartPDFViewer.prototype.init = function() {

    window.PDFJS.disableWorker = false;
    window.PDFJS.workerSrc = window.BASE_PATH + 'js/pdfjs/pdf.worker.js';

    this.previewPlaceholder = $('#pdfPreviewSectionId');

    this.spinnerController = this._initSpinner();

    this.moire = $('#pdfPreviewSectionMoireId');

    this.currentPDF = null;
    this.currentPageForRender = 1;

    this.renderBreaker = { // need for break rendering process
        needBreak: false
    };

    return this;
};

ChartPDFViewer.prototype.showPDF = function(pdfData) {

    var newRenderBreaker = {needBreak: false};
    this.renderBreaker = newRenderBreaker;

    var self = this;

    window.PDFJS.getDocument({data: pdfData}).then(
        function getPdfPreview(pdf) {
            self.currentPDF = pdf;
            self.currentPageForRender = 1;
            self._renderNextPage(newRenderBreaker);
        }
    );
};

ChartPDFViewer.prototype._clearPlaceholder = function() {
    this.previewPlaceholder.empty();
    this.previewPlaceholder.scrollLeft(0); //need for chrome
    this.previewPlaceholder.scrollTop(0);
};

ChartPDFViewer.prototype._appendPageElement = function(pageNumber, maxPages, width, height) {
    var pageDiv = document.createElement('div');
    pageDiv.setAttribute('class', 'pdfPreviewPage');
    pageDiv.setAttribute('id', 'pdfPage_' + pageNumber);
    pageDiv = $(pageDiv).innerWidth(width).innerHeight(height);

    var pageNumFlag = document.createElement('div');
    pageNumFlag.setAttribute('class', 'pageNumInfo');
    pageNumFlag = $(pageNumFlag).html('<div>' + pageNumber + '/' + maxPages + '</div>');

    var canvas = document.createElement('canvas');
    canvas.height = height;
    canvas.width = width;

    pageDiv.append(pageNumFlag);
    pageDiv.append(canvas);

    this.previewPlaceholder.append(pageDiv);
};

ChartPDFViewer.prototype._getCurrentPageCanvasContext = function(currentPageNum) {
    return this.previewPlaceholder.find('#pdfPage_' + currentPageNum).find('canvas')[0].getContext('2d');
};

ChartPDFViewer.prototype._renderNextPage = function(renderBreaker) {
    var self = this;

    if (renderBreaker.needBreak) {
        return;
    }

    this.currentPDF.getPage(this.currentPageForRender).then(
        function renderPage(page) {

            if (renderBreaker.needBreak)
                return;

            var scale = 0.70;
            var viewport = page.getViewport(scale);

            // if first page - render all empty pages
            if (self.currentPageForRender === 1) {
                for (var i = 1; i <= self.currentPDF.numPages; i++) {
                    self._appendPageElement(i, self.currentPDF.numPages, viewport.width, viewport.height);
                }
            }

            // Render PDF page into canvas context.
            var renderContext = {
                canvasContext: self._getCurrentPageCanvasContext(self.currentPageForRender),
                viewport: viewport
            };
            // used promises for asynchronous rendering each page
            page.render(renderContext).promise.then(
                function() {

                    if (self.currentPDF.numPages === 1 || self.currentPageForRender === 2) {
                        //if already render 2 page - hide moire
                        self.hideMoire();
                    }
                    self.currentPageForRender++;
                    if (self.currentPageForRender <= self.currentPDF.numPages) {

                        self._renderNextPage(renderBreaker);
                    }
                }
            );
        }
    );
};

ChartPDFViewer.prototype._initSpinner = function() {
    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 8, // The length of each line
        width: 3, // The line thickness
        radius: 6, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#888888', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    var spinnerController = new SpinnerController();
    spinnerController.setSpinner(new Spinner(spinnerOptions));

    return spinnerController;
};

ChartPDFViewer.prototype.interruptPreview = function() {
    this.renderBreaker.needBreak = true;
    this._clearPlaceholder();
};

ChartPDFViewer.prototype.showMoire = function() {
    this.spinnerController.spin('previewChartPDFSpinner');
    this.moire.show();
    this._clearPlaceholder();
};

ChartPDFViewer.prototype.hideMoire = function() {
    this.moire.hide();
    this.spinnerController.stop()
};

export default ChartPDFViewer


// WEBPACK FOOTER //
// ./web/js/reports/charts/pdfpreview/ChartPDFViewer.js